import { render, staticRenderFns } from "./advancedSetting.vue?vue&type=template&id=5b23b012&scoped=true"
import script from "./advancedSetting.vue?vue&type=script&lang=js"
export * from "./advancedSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23b012",
  null
  
)

export default component.exports